import http, { expandURI } from '@/utils/ajax'
import { MYQI_INIT_LOADING, MYQI_INIT_SUCCESS, MYQI_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  myQuotationsIssued: {
    init: 0,
    menu: {},
    noQuote: null,
    lastUpdated: null,
    scope: null,
    info: null,
    appIds: []
  }
}

const getters = {

}

const actions = {
  async initMyQuotationsIssued({ commit, state }, data) {
    commit(MYQI_INIT_LOADING)
    const apiUrl = state.permitWidgets.myQuotationsIssued
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to)
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)
        Object.assign(data, {
          menu: menu,
          noQuote: result.data.noQuote,
          info: result.data.info,
          appIds: result.data.appIds
        })
        commit(MYQI_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYQI_INIT_FAIL)
      }
    } else {
      commit(MYQI_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYQI_INIT_LOADING](state) {
    state.myQuotationsIssued.init = 0
  },
  [MYQI_INIT_SUCCESS](state, data) {
    const { myQuotationsIssued } = state
    myQuotationsIssued.menu = data.menu
    myQuotationsIssued.init = 1
    myQuotationsIssued.lastUpdated = new Date()
    myQuotationsIssued.scope = data.scope
    myQuotationsIssued.noQuote = data.noQuote
    myQuotationsIssued.info = data.info
    myQuotationsIssued.appIds = data.appIds
  },
  [MYQI_INIT_FAIL](state) {
    state.myQuotationsIssued.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
